"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const audiences = [{
  id: "01",
  label: "CEO & FOUNDER",
  title: "Per la visione",
  description: "Imprenditori, founder di startup, titolari di PMI, manager con esperienza reale."
}, {
  id: "02",
  label: "MARKETERS & COMUNICATORI",
  title: "Per la strategia",
  description: "Responsabili marketing, art director, esperti SEO, copywriter, titolari di agenzie."
}, {
  id: "03",
  label: "CREATIVI",
  title: "Per immaginare",
  description: "Artisti, fotografi, videomaker, registi, designer, illustratori."
}];
export default function CoreAudienceEditorial() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: listRef,
    isVisible: isListVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: quoteRef,
    isVisible: isQuoteVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="coreaudienceeditorial" className="relative overflow-hidden bg-background py-24 md:py-32 !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_03.webp)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_01.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/studio_episode_01.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/visionary_lens.png)]">
      {}
      <div className="pointer-events-none absolute right-0 top-1/2 z-0 -translate-y-1/2 translate-x-1/4 opacity-[0.03] dark:opacity-[0.05]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/lion_watermark_graphic.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/lion_watermark_graphic.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/lion_watermark_graphic.png-wvc-sizes" alt="" className="h-auto w-[600px] max-w-none object-contain md:w-[800px] lg:w-[1000px]" loading="lazy" />
      </div>

      <div className="container relative z-10 mx-auto px-6">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-8">
          {}
          <div ref={headerRef} className={`lg:col-span-8 transition-all duration-1000 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <span className="mb-8 block text-sm font-bold tracking-widest text-primary uppercase">
              Chi cerchiamo
            </span>
            <h2 className="font-default text-6xl font-bold leading-[0.9] tracking-tighter text-foreground md:text-[5.5rem] lg:text-[6.5rem]">
              Persone
              <br />
              con un
              <br />
              <span className="text-primary">
                punto
                <br />
                di vista.
              </span>
            </h2>
          </div>

          {}
          <div ref={listRef} className={`mx-auto flex flex-col justify-center space-y-12 lg:col-span-4 lg:pt-24 transition-all duration-1000 delay-200 ease-out ${isListVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            {audiences.map((item, i) => <div key={item.id} data-index={i} className="group flex items-start gap-6">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-border/50 bg-background/50 text-sm font-bold text-primary shadow-sm transition-colors group-hover:border-primary/50 group-hover:bg-primary/5">
                  {item.id}
                </div>
                <div className="flex flex-col pt-1">
                  <span className="mb-2 text-xs font-bold tracking-widest text-muted-foreground uppercase">
                    {item.label}
                  </span>
                  <h3 className="font-default mb-3 text-2xl font-bold text-foreground">
                    {item.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-muted-foreground">
                    {item.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {}
        <div ref={quoteRef} className={`mt-32 text-center transition-all duration-1000 delay-300 ease-out ${isQuoteVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <p className="text-lg font-bold italic text-primary md:text-xl"><span className="!text-left">"Non cerchi pubblicità - cerchi una conversazione autentica."</span></p>
        </div>
      </div>
    </section>;
}